import React from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'inflect';

import Fetchable from '~/commons/components/util/Fetchable';

import Scroll from '../../layout/Scroll';
import Page from '../../layout/Page';
import { getLevel } from '../../helpers';
import Avatar from '../../mods/Avatar';
import Level from '../../mods/Level';

const PageProfile = () => {
  const { t, i18n } = useTranslation();

  return (
    <Page>
      <Fetchable
        req={[
          { url: '/api/users/self' },
          { url: '/api/levels', params: { sort: { score: 1 } } },
        ]}
      >
        {([user, { rows: levels }]) => {
          const lv = getLevel(levels, user.score);

          return (
            <div className="container">
              <Scroll fillScreen>
                <div className="text-center px-3">
                  <div className="profile-avatar">
                    <Avatar />
                  </div>

                  {/* basic info */}
                  <div className="row justify-content-center my-4">
                    <div className="col-md-8">
                      <div className="row fs-6 fs-md-5 fw-bold gy-4">
                        <div className="col-12 col-lg">
                          <div className="border border-2 border-primary rounded-pill p-3 px-2">
                            <div className="text-truncate flex-fill">
                              {titleize(t('name'))}
                              ：
                              {user.username}
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-lg">
                          <div className="border border-2 border-primary rounded-pill p-3 px-2">
                            {titleize(t('level'))}
                            ：
                            {i18n.pickLng(lv.current.title)}
                          </div>
                        </div>
                        <div className="col-12 col-lg">
                          <div className="border border-2 border-primary rounded-pill p-3 px-2">
                            {titleize(t('score'))}
                            ：
                            {t('scoreInUnit', user)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* level progress */}
                  <h3 className="fw-bold">
                    {t('pg.game.levelsPath')}
                  </h3>
                  <div className="row justify-content-center">
                    {levels.map((l) => (
                      <Level
                        key={l._id}
                        className="col-auto"
                        level={l}
                        scored={user.score}
                        progress={lv.next?._id === l._id}
                        current={lv.current}
                        redemption
                        redeemed={user.redemptions.includes(l._id)}
                      />
                    ))}
                  </div>
                </div>
              </Scroll>
            </div>
          );
        }}
      </Fetchable>
    </Page>
  );
};

export default PageProfile;
